<template>
	<vTable :columns="columns" :data="data" border></vTable>
</template>
<script>
export default {
    props:['data'],
	computed: {
		columns() {
			return [{
				title: this.$t('global.common.operator', { defaultValue: '操作人' }),
				key: 'createdName',
			}, {
				title: this.$t('global.common.operate_type', { defaultValue: '操作类型' }),
				key: 'opAction',
			}, {
				title: this.$t('global.common.operate_note', { defaultValue: '操作原因 ' }),
				key: 'opRemark',
			}, {
				title: this.$t('global.common.operate_time', { defaultValue: '操作时间 ' }),
				key: 'createdAt',
			}];
		}
	}
}
</script>
